import React from 'react';

import { DutyHourTypeDynFlag } from 'generated';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const employeePortalSectionSchema = Yup.object().shape({
  flags: Yup.array().default(['SHOW_IN_TEAMROSTER'])
});

export const EmployeePortalSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MultiStepForm.Section title={t('employeePortal')}>
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="EXS_DUTY_TIMES_EDIT"
        label={t('dutyHourTypes.fieldName.editDutyTime')}
      />
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="EXS_DUTY_TIMES_CREATE"
        label={t('dutyHourTypes.fieldName.createDutyTime')}
      />
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="EXS_ABSENCE_REQ"
        label={t('dutyHourTypes.fieldName.leaveRequest')}
      />
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="SHOW_IN_TEAMROSTER"
        label={t('dutyHourTypes.fieldName.showInTeamroster')}
      />
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="SHOW_ABSENCE_TYPE_IN_TEAMROSTER"
        label={t('dutyHourTypes.fieldName.showAbsenceTypeInTeamroster')}
      />
    </MultiStepForm.Section>
  );
};
